import type { DayCloseSessionRow } from '#shared/types';
import { ENDPOINT, withQuery } from '#client/lib/endpoints';
import { countOf } from '#client/lib/format';

/** The day-close request: one day, optionally narrowed to one staff member. */
export function dayCloseUrl(on: string, staff: string): string {
  return withQuery(ENDPOINT.dayClose, { on, user_id: staff });
}

interface WhoseInput {
  /** The staff member the server narrowed to, or null for the whole lab. */
  userId: number | null;
  /** Whether the viewer may look at anyone's figures. */
  canReviewAll: boolean;
  people: readonly { id: number; name: string }[];
}

/** Whose figures the page is showing, as its subtitle says it. */
export function describeWhose({ userId, canReviewAll, people }: WhoseInput): string {
  if (userId === null) return 'All staff';
  if (!canReviewAll) return 'Your figures';
  return people.find((person) => person.id === userId)?.name ?? 'One staff member';
}

export function dayCloseSubtitle(whose: string, registrations: number, on: string): string {
  return `${whose} · ${countOf(registrations, 'registration')} on ${on}`;
}

type SessionFigures = DayCloseSessionRow['live'];

/** The live figures no longer match what was signed off. */
export function hasDrifted(row: {
  live: SessionFigures;
  submission: { snapshot: SessionFigures } | null;
}): boolean {
  const snapshot = row.submission?.snapshot;
  if (!snapshot) return false;
  return (
    snapshot.registrations !== row.live.registrations ||
    snapshot.billed !== row.live.billed ||
    snapshot.collected !== row.live.collected
  );
}
